import React from 'react';
import { Link } from 'react-router-dom';

const ProjectStickyFull = () => {
  const projects = [
    {
      id: 1,
      title: "Nagpur Skill Centre — skills policy in action",
      desc: "AID co-sponsors the Nagpur Skill Centre with Tata STRIVE and Nagpur Municipal Corporation — a 30,000-sqft hub designed to train thousands annually in industry-aligned trades…",
      bgImg: "img/portfolio/3.jpg",
      link: "https://timesofindia.indiatimes.com/city/nagpur/nagpur-skill-centre-set-to-make-a-big-impact-in-country/articleshow/125023364.cms?utm_source=chatgpt.com"
    },
    {
      id: 2,
      title: "Employment partnership with Apna.co",
      desc: "AID’s MoU-style collaboration with hiring platform Apna.co (via Advantage Vidarbha) aims to provide hiring credits and direct employer–candidate access.…",
      bgImg: "img/portfolio/2.jpg",
      link: "https://education.economictimes.indiatimes.com/news/industry/apna-co-and-advantage-vidarbha-sign-mou-to-strengthen-employment-with-inr-60-crore-initiative/118144316?utm_source=chatgpt.com"
    },
    {
      id: 3,
      title: "Inputs to Maharashtra’s GCC Policy",
      desc: "AID ensured Maharashtra’s GCC policy includes benefits for Tier-2/3 cities like Nagpur, enabling incentives and support that shift high-value IT jobs to Vidarbha.…",
      bgImg: "img/portfolio/1.jpg",
      link: "https://timesofindia.indiatimes.com/city/nagpur/aid-welcomes-govt-move-to-include-suggestions-in-gcc-policy/articleshow/124297309.cms?utm_source=chatgpt.com"
    },
    {
      id: 4,
      title: " FamilyCap Nagpur — startup funding",
      desc: "ID’s FamilyCap Nagpur platform organizes local business families to commit funding and mentorship to 50 Vidarbha startups, addressing a major policy gap.…",
      bgImg: "img/portfolio/4.jpg",
      link: "https://timesofindia.indiatimes.com/city/nagpur/business-families-to-invest-rs25-crore-in-50-vidarbha-startups/articleshow/121540635.cms?utm_source=chatgpt.com"
    }
  ];

  return (
    <div className="fn_cs_project_sticky_full">
      <div className="inner">
        <div className="left_part">
          <div className="fn_cs_sticky_section">
            <h3>Our Policy Initiatives.</h3>
            <p>AID actively drives policy advocacy to position Vidarbha as a leading industrial destination. We facilitate industry–government dialogue, address regulatory challenges, and push for industry-friendly policies across priority sectors.</p>
            <p>AID works closely with policymakers to promote investment, improve infrastructure, strengthen skill development, and ensure a unified voice for Vidarbha’s industrial ecosystem.</p>
            <Link to="/policy-advocacy">View Policy Initiatives</Link>
          </div>
        </div>
        
        <div className="right_part compact">
          <div className="fn_cs_sticky_section">
            <ul className="compact-list">
              {projects.map(project => (
                <li key={project.id} className="compact-item">
                  <div className="item" style={{ display: 'flex', alignItems: 'stretch', gap: '20px' }}>
                    <div className="img_holder compact-img" style={{ width: '50%', paddingBottom: '50%', position: 'relative', overflow: 'hidden' }}>
                      <img src="img/thumb/700-500.jpg" alt="" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover' }} />
                      <div className="abs_img" data-bg-img={project.bgImg} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}></div>
                      <Link to={project.link} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}></Link>
                    </div>
                    <div className="title_holder" style={{ width: '50%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                      <h3><Link to={project.link}>{project.title}</Link></h3>
                      <span className="desc compact-desc">{project.desc}</span>
                      <p className="compact-link">
                        <Link to={project.link}>
                          <span className="text">More Details</span>
                          <span className="arrow">
                            <img className="fn__svg" src="svg/arrow-r.svg" alt="svg" />
                          </span>
                        </Link>
                      </p>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectStickyFull;